// extracted by mini-css-extract-plugin
export default {"page":"Missions_page__JddTm","container":"Missions_container__H043v","missionTextBox":"Missions_missionTextBox__soCz5"};